export default {
  required: 'Required',
  incompleteFieldList: 'Complete first: {fields}',
  unboundIssueListHeader: 'Fix these issues before saving',
  discardHeader: 'Discard unsaved changes?',
  discardMessage: 'This will delete all edits since you last saved.',
};
